import { Injectable } from '@angular/core';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { BusinessIdService } from 'src/libs/shared-services/businessid.service';
import { SwitchUserRequest, SwitchUserService } from 'src/libs/shared-services/switchuser.service';
import { PageDetails, UserResourceService } from 'src/libs/api-client';

// global state is either service properties OR browser storage
// - edge case: login info
@Injectable({
  providedIn: 'root'
})
export class GlobalState {

  constructor(
    private businessIdService: BusinessIdService, 
    private afAuth: AngularFireAuth,
    private switchUserService: SwitchUserService,
    private userApiService: UserResourceService
  ) { } 

  private showMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getShowMenu$()
  {
    return this.showMenu;
  }

  async getAllowedPagesv2() : Promise<{ [key: string]: PageDetails }>
  {
    const allowedPagesString = sessionStorage.getItem("allowedPages");
    if(allowedPagesString) {
      const storedArray : { [key: string]: PageDetails } = JSON.parse(allowedPagesString);
      return storedArray;
    }

    var allowedPages: { [key: string]: PageDetails } = await firstValueFrom(this.userApiService.userResourceGetMyAllowedPages());
    sessionStorage.setItem("allowedPages", JSON.stringify(allowedPages));

    return allowedPages
  }

  async getAllowedPages() : Promise<string[]>
  {
      const allowedPagesString = sessionStorage.getItem("allowedPages");
      if(allowedPagesString) {
        const storedArray : { [key: string]: PageDetails } = JSON.parse(allowedPagesString);
        return this.getKeys(storedArray);
      }
  
      var allowedPages: { [key: string]: PageDetails } = await firstValueFrom(this.userApiService.userResourceGetMyAllowedPages());
      sessionStorage.setItem("allowedPages", JSON.stringify(allowedPages));

      return this.getKeys(allowedPages);
  }

  getKeys(valuesReturned: { [key: string]: PageDetails }): string[] {

    const found = Object.entries(valuesReturned);

    const keys = found.map(([key, value]) => key);
    return keys;
  }

  getCurrentBusinessId()
  {
    return this.businessIdService.getCurrentBusinessId();
  }

  getIsEmulatingUser() : string | null
  {
    return sessionStorage.getItem("user-to-emulate");
  }

  switchShowMenuOn(){
    this.showMenu.next(true);
  }

  switchShowMenuOff(){
    this.showMenu.next(false);
  }

  switchShowMenuState(){
    const currentStateSwitched = !this.showMenu.value;
    this.showMenu.next(currentStateSwitched);
  }

  async logout()
  {
    const switchUserRequest : SwitchUserRequest= {
      keysToKeep: [],
      logOutUser: true
    }
    
    await this.switchUserService.switchUserService(switchUserRequest);

    window.location.href = "/login";
  }
}